export interface Page {
  id: string;
  name: string;
}

export interface Component {
  name: string;
  id: string;
}

export interface Subscriber {
  id: string;
  created_at: string;
  mode: string;
  email?: string;
  endpoint?: string;
  display_phone_number?: string;
  purge_at?: string;
  quarantined_at?: string;
  skip_confirmation_notification?: boolean;
}

export class Subscriber {
  static displayMode(subscriber: Subscriber): string | undefined {
    switch (subscriber.mode) {
      case 'email':
        return 'Email';
      case 'sms':
        return 'SMS';
      case 'webhook':
        return 'Webhook';
    }
  }

  static identifier(subscriber: Subscriber): string | undefined {
    switch (subscriber.mode) {
      case 'email':
        return subscriber.email;
      case 'sms':
        return subscriber.display_phone_number;
      case 'webhook':
        return subscriber.endpoint;
    }
  }
}
